import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from 'react-i18next';

export const MultiSelect = ({ options, onChange, disabled = false, placeholder, value = null }) => {
  const [selected, setSelected] = useState([]);
  const { t } = useTranslation();

  // Si se proporciona un prop value, usarlo como fuente de verdad (componente controlado)
  // Si value es null, usar estado interno (componente no controlado)
  const isControlled = value !== null && value !== undefined;

  // Sincronizar estado interno cuando cambia el prop value (componente controlado)
  useEffect(() => {
    if (isControlled) {
      // Convertir array de valores a formato de react-select
      if (Array.isArray(value) && value.length === 0) {
        setSelected([]);
      } else if (Array.isArray(value) && value.length > 0 && options && options.length > 0) {
        const selectedOptions = options.filter(opt => value.includes(opt.value));
        setSelected(selectedOptions);
      } else if (!Array.isArray(value) || value.length === 0) {
        setSelected([]);
      }
    }
  }, [value, isControlled, options]);

  // Reset selected when options change (but don't call onChange to avoid infinite loops)
  useEffect(() => {
    if (!isControlled) {
      // Solo manejar estado interno si no es controlado
      if (!options || options.length === 0) {
        setSelected([]);
        // No llamar onChange aquí para evitar bucles infinitos
        // onChange([]);
      } else {
        // Filtrar los valores seleccionados para mantener solo los que aún existen en las opciones
        setSelected(prevSelected => {
          const validSelected = prevSelected.filter(selected => 
            options.some(opt => opt.value === selected.value)
          );
          // Solo actualizar si hay cambios
          if (validSelected.length !== prevSelected.length) {
            return validSelected;
          }
          return prevSelected;
        });
      }
    }
  }, [options, isControlled]);

  const handleChange = (event) => {
    const newSelected = event || [];
    setSelected(newSelected);
    onChange(newSelected.map((item) => item.value));
  };

  return (
    <Select
      isMulti
      options={options}
      value={selected}
      onChange={handleChange}
      placeholder={placeholder || t("search.selectEntities")}
      isDisabled={disabled}
      styles={{
        control: (base) => ({
          ...base,
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }),
      }}
    />
  );
};
